module.exports = __webpack_public_path__ + "img/gravier_monts_darree.5e361df6.jpg";